import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Typography, Card } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) => ({
  tooltip: {
    background: theme.palette.primary.main,
    padding: theme.spacing(2),
    margin: 0,
  },
  tooltipText: {
    fontSize: 14,
    fontWeight: 300,
    color: theme.palette.primary.contrastText,
  },
}));

interface IRegisterFormTooltipTitleProps {}

export const RegisterFormTooltipTitle: FunctionComponent<IRegisterFormTooltipTitleProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Card className={classes.tooltip}>
      <Typography className={classes.tooltipText} align="center">
        {t("login.register_email_info")}
      </Typography>
    </Card>
  );
};
